"use client";

import React from "react";
import { Truck, ShieldCheck, RotateCcw, Award, Headphones } from "lucide-react";

export default function CartTrustBadges() {
  const trustItems = [
    {
      icon: Truck,
      title: "Fast Shipping",
      desc: "Dispatched within 24-48 hours",
    },
    {
      icon: ShieldCheck,
      title: "Secure Payments",
      desc: "256-bit SSL encryption",
    },
    {
      icon: RotateCcw,
      title: "Easy Returns",
      desc: "Hassle-free 30-day policy",
    },
    {
      icon: Award,
      title: "Premium Quality",
      desc: "100% genuine craftsmanship",
    },
    {
      icon: Headphones,
      title: "24/7 Support",
      desc: "Dedicated customer service",
    },
  ];

  return (
    <div className="mt-10 p-6 bg-slate-50 border border-slate-200/70 rounded-[12px]">
      <h4 className="text-sm font-bold text-slate-800 text-center mb-5">
        Why Shop With Us?
      </h4>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-4">
        {trustItems.map((item, idx) => {
          const Icon = item.icon;
          return (
            <div key={idx} className="flex flex-col items-center text-center space-y-1.5 p-2">
              <div className="w-10 h-10 rounded-full bg-white border border-slate-200/80 shadow-xs flex items-center justify-center text-[var(--brand-accent)]">
                <Icon className="w-5 h-5" />
              </div>
              <p className="text-xs font-bold text-slate-800">{item.title}</p>
              <p className="text-[10px] text-slate-500 font-medium leading-tight">{item.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
